import React, {Component} from 'react';
import {Row, Col} from "react-bootstrap";
import {TopButtonAction} from "../../../../../componentsTopsa/buttons/TopButtons";
import {TopAlertInformacja, TopAlertOstrzezenie, TopAlertUwaga} from "../../../../../componentsTopsa/alerty/TopAlerts";
import acc from 'accounting'
import FirmyService from "../../../../klienciConfig/firmy/FirmyService";
import FirmyForm from "../../../../klienciConfig/firmy/components/FirmyForm";
import BiletyService from "../../biletyApi/BiletyService";

export default class WystawFaktureZaBiletMiesieczny extends Component {
    constructor(props) {
        super(props);
        this.state = {
            setLoaderFirmy: false,
            restResult: false,
            pokazFormularzDodawaniaEdycjiFirmy: false,
            firmaDoFaktury: null,
        };
    }

    componentDidMount() {
        if (Boolean(this.props.bilet)) {
            if (Boolean(this.props.bilet.nipParagon)) {
                this.wyszukajFirmePoNipie(
                    this.props.bilet.nipParagon
                )
            }
        }
    }


    renderPartInformation(icon, label, value, czyLabelClass, labelWidth = 150) {
        return (<div style={{marginBottom: '15px'}}>
            <i className={icon} style={{width: '25px', display: 'inline-block'}}></i>
            <span style={{display: 'inline-block', minWidth: labelWidth + 'px'}}>{label}</span>
            {
                Boolean(czyLabelClass) ?
                    <span className={czyLabelClass} style={{fontSize: 'inherit'}}>{value}</span>
                    :
                    <span style={(label === 'Cena') ? {fontWeight: 'bold'} : {}}>{value}</span>
            }
        </div>)
    }


    wyszukajFirmePoNipie = (nip) => {

        this.setState({setLoaderFirmy: true})

        FirmyService.szukajFirmePoNipieAlboPoNazwie(nip)
            .then((response) => {
                console.log(response)

                let znaleziono = false;

                if (Boolean(response.data)) {
                    if (response.data.content.length > 0) {
                        znaleziono = true
                    }
                }


                if (znaleziono) {
                    this.setState({
                        firmaDoFaktury: response.data.content[0]
                    })
                } else {
                    this.setState({
                        pokazFormularzDodawaniaEdycjiFirmy: true
                    })
                }

                this.setState({setLoaderFirmy: false})

            })
            .catch(err => {
                console.log(err)
                this.setState({
                    pokazFormularzDodawaniaEdycjiFirmy: true,
                    setLoaderFirmy: false
                })
            })
    }

    onClickZapiszFirme = (obj, czyEdycja) => {

        FirmyService.addFirma(obj).then(function (response) {
            if (response) {
                if (response.data) {
                    this.setState({
                        firmaDoFaktury: response.data,
                    })
                }
            }
        }.bind(this))
    }

    wystawFakture() {
        if (Boolean(this.state.firmaDoFaktury)) {
            let obj = {
                idBm: this.props.bilet.idBm,
                idFi: this.state.firmaDoFaktury.idFi,
            }


            BiletyService.zamienParagonNaFaktureBiletMiesieczny(obj)
                .then(function (response) {
                    if (response.status < 300) {
                        this.setState({
                            restResult: {success: true}
                        })
                        setTimeout(function () {
                            this.props.handleClickZamknij();
                        }.bind(this), 3000)
                    }
                    else {
                        this.setState({
                            restResult: {success: false}
                        })
                        setTimeout(function () {
                            this.setState({
                                restResult: null
                            })
                        }.bind(this), 4000)
                    }
                }.bind(this))
                .catch(function (err) {
                    this.setState({
                        restResult: {success: false}
                    })
                    setTimeout(function () {
                        this.setState({
                            restResult: null
                        })
                    }.bind(this), 4000)
                }.bind(this))


        }
        else {
            alert('Nie wybrano firmy!')
        }
    }


    render() {

        return (
            <div>
                <div id={'EBUSModalContainerBG'}>
                    <div id={'modalContainer'} className={'modalFakturaDuzy'}>
                        <div>
                            <div id={'modalTextContent'}>
                                <div>
                                    <div className={'pull-right'}>
                                        <TopButtonAction onClick={() => {
                                            this.props.handleClickZamknij()
                                        }}
                                                         elementStyle={{color: 'firebrick'}}
                                                         btnColor={'default'} text={'Zamknij'}
                                                         iconType={'fa fa-times'}
                                        />

                                    </div>
                                </div>
                                <div style={{clear: 'both', height: '15px'}}></div>
                                {
                                    Boolean(this.state.restResult) ?
                                        (this.state.restResult.success) ?
                                            <h4>
                                                <div>
                                                    <i className={'fa fa-check'} style={{color: 'forestgreen'}}></i> Pomyślnie wystawiono fakturę
                                                </div>
                                                <div style={{marginTop: '15px', color: 'grey', fontStyle: 'italic'}}>
                                                    Za chwilę nastąpi zamknięcie okna
                                                </div>
                                            </h4>

                                            :

                                            <h4>
                                                <div>
                                                    <i className={'fa fa-times'} style={{color: 'firebrick'}}></i> Wystąpił błąd podczas próby
                                                    wystawienia faktury
                                                </div>
                                                <div style={{marginTop: '15px', color: 'grey', fontStyle: 'italic'}}>
                                                    Proszę ponowić próbę
                                                </div>
                                            </h4>
                                        :
                                        Boolean(this.props.bilet) ?
                                            <div style={{padding: '0 15px 100px 15px', maxHeight: '70vh', overflowY: 'auto'}}>
                                                <h4>Wystaw fakturę VAT na bilet miesięczny</h4>
                                                <div>
                                                    <Row>
                                                        <Col xs={12} lg={4}>
                                                            <h5 style={{fontStyle: 'italic', color: 'grey'}}>Informacje o bilecie</h5>
                                                            {this.renderPartInformation('fa fa-id-card-o', 'Numer karty', this.props.bilet.nrKarty, 'label label-ebus-primary')}
                                                            {this.renderPartInformation('fa fa-road', 'Odcinek', this.props.bilet.nazMiOd + " - " + this.props.bilet.nazMiDo, '')}
                                                            {this.renderPartInformation((this.props.bilet.kierunek == 1) ? 'fa fa-long-arrow-right' : 'fa fa-exchange', 'Kierunek', (this.props.bilet.kierunek == 1) ? 'jednostronny' : 'dwustronny', '')}
                                                            {this.renderPartInformation('fa fa-calendar-o', 'Ważny', this.props.bilet.waznyOd + ' - ' + this.props.bilet.waznyDo, '')}

                                                        </Col>
                                                        <Col xs={12} lg={4}>
                                                            <h5 style={{fontStyle: 'italic', color: 'grey'}}>Informacje o zniżce i cenie</h5>
                                                            {this.renderPartInformation('fa fa-percent', 'Zniżka', '(' + this.props.bilet.rodz + ') ' + this.props.bilet.nazZniz, '', 100)}
                                                            {this.renderPartInformation('fa fa-tag', 'Typ', (this.props.bilet.handlowa) ? 'handlowa' : 'ustawowa', '', 100)}
                                                            {this.renderPartInformation('fa fa-money', 'Cena', acc.formatMoney(this.props.bilet.cena), '', 100)}
                                                        </Col>
                                                        <Col xs={12} lg={4}>
                                                            <h5 style={{fontStyle: 'italic', color: 'grey'}}>Informacje o kliencie</h5>
                                                            {(this.props.bilet.nazKl) ? this.renderPartInformation('fa fa-user-circle-o', 'Klient', this.props.bilet.imieKl + ' ' + this.props.bilet.nazKl, '') : ''}
                                                            {(this.props.bilet.peselKl) ? this.renderPartInformation('fa fa-id-card', 'PESEL', this.props.bilet.peselKl, '') : ''}
                                                            {(this.props.bilet.telefonKl) ? this.renderPartInformation('fa fa-phone', 'Telefon', this.props.bilet.telefonKl, '') : ''}
                                                            {(this.props.bilet.emailKl) ? this.renderPartInformation('fa fa-envelope-o', 'Email', this.props.bilet.emailKl, '') : ''}
                                                        </Col>
                                                    </Row>
                                                </div>
                                                <div style={{marginTop: '25px'}}>

                                                    {
                                                        this.state.setLoaderFirmy ?

                                                            <div id={'smallLoader'}>
                                                                <i className={'fa fa-circle-o-notch fa-spin'}></i>
                                                                <div>Trwa ładowanie firmy...</div>
                                                            </div>

                                                            :


                                                            (Boolean(this.state.firmaDoFaktury)) ?

                                                                <div>
                                                                    <TopAlertInformacja
                                                                        text={'Znaleziono następującą firmę, bazując na NIP podanym na paragonie:'}/>
                                                                    <div style={{
                                                                        border: "1px solid #ccc",
                                                                        background: "#f5f5f5",
                                                                        padding: '15px',
                                                                        margin: '15px 0'
                                                                    }}>
                                                                        <h4 style={{marginTop: 0, textAlign: 'left'}}>
                                                                            NIP: <span className={'label label-ebus-primary'}
                                                                                       style={{fontSize: 'inherit'}}>{this.state.firmaDoFaktury.nip}</span>
                                                                        </h4>
                                                                        <h3>
                                                                            {this.state.firmaDoFaktury.nazwa}
                                                                        </h3>
                                                                        <p>
                                                                            {(this.state.firmaDoFaktury.regon) && 'REGON: ' + this.state.firmaDoFaktury.regon}
                                                                        </p>
                                                                        <p>
                                                                            {(this.state.firmaDoFaktury.kodPocztowy) && this.state.firmaDoFaktury.kodPocztowy + ' '}
                                                                            {this.state.firmaDoFaktury.miejscowosc + ', '}
                                                                            {(this.state.firmaDoFaktury.ulica) && this.state.firmaDoFaktury.ulica + ', '}
                                                                            <div>
                                                                                {(this.state.firmaDoFaktury.wojewodztwo) && 'woj. ' + this.state.firmaDoFaktury.wojewodztwo}
                                                                            </div>
                                                                        </p>
                                                                    </div>
                                                                </div>
                                                                :
                                                                Boolean(this.props.bilet) &&
                                                                <div>
                                                                    <TopAlertOstrzezenie
                                                                        text={'Nie znaleziono firmy w bazie, proszę ją najpierw dodać w formularzu poniżej'}/>
                                                                    <FirmyForm
                                                                        nipFirmy={this.props.bilet.nipParagon}
                                                                        usunButtonAnuluj={true}
                                                                        handleClickZapisz={this.onClickZapiszFirme}
                                                                    />
                                                                </div>

                                                    }
                                                    <div>
                                                        <div style={{height: '25px'}}></div>
                                                        <TopButtonAction text={'Wystaw fakturę'} iconType={'fa fa-file-text-o'}
                                                                         btnColor={'primary'} btnSize={'md'}
                                                                         btnDisabled={!Boolean(this.state.firmaDoFaktury)}
                                                                         onClick={() => {
                                                                             this.wystawFakture()
                                                                         }}/>
                                                    </div>

                                                </div>
                                            </div>
                                            :
                                            <TopAlertUwaga text={'Wystąpił błąd z załadowaniem danych'}/>
                                }

                                <div style={{clear: 'both'}}></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/modules/konfiguracja/biletyConfig/fakturyBilety/externalComponents/WystawFaktureZaBiletMiesieczny.js